import { FOOTER_COLUMNS, POLICY_LINKS, SITE } from '@/data/site.ts';
import { asset, href } from '@/lib/paths.ts';

export function Footer() {
  return (
    <footer className="footer">
      <div
        className="container--wide"
        style={{ padding: '0 clamp(1.5rem, 4vw, 4rem)' }}
      >
        <div className="footer__grid">
          <div className="footer__brand">
            <img
              src={asset(SITE.logo)}
              alt="Lux Financial"
              width={341}
              height={69}
              loading="lazy"
            />
            <p>
              Helping high net worth individuals offset tax equity through
              strategic energy investment programs.
            </p>
          </div>

          {FOOTER_COLUMNS.map((col) => (
            <nav key={col.heading} aria-labelledby={`footer-${col.heading}`}>
              <h2 className="footer__heading" id={`footer-${col.heading}`}>
                {col.heading}
              </h2>
              {col.links.map((link) => (
                <a
                  key={link.href}
                  href={
                    'external' in link && link.external
                      ? link.href
                      : href(link.href)
                  }
                  className="footer__link"
                  {...('external' in link && link.external
                    ? { target: '_blank', rel: 'noopener noreferrer' }
                    : {})}
                >
                  {link.label}
                </a>
              ))}
            </nav>
          ))}

          <div>
            <h2 className="footer__heading" id="footer-contact">
              Contact
            </h2>
            <a href={SITE.phoneHref} className="footer__link">
              {SITE.phone}
            </a>
            <a
              className="footer__link"
              href={SITE.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {SITE.address.street.replace(', Suite 475', '')}
              <br />
              Suite 475, {SITE.address.locality}, {SITE.address.region}{' '}
              {SITE.address.postalCode}
            </a>
          </div>
        </div>

        <div className="footer__bottom">
          <span suppressHydrationWarning>
            &copy; {new Date().getFullYear()} Lux Financial. All rights
            reserved.
          </span>
          <div className="footer__bottom-links">
            {POLICY_LINKS.map((link) => (
              <a key={link.href} href={href(link.href)}>
                {link.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
